import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Skeleton } from '@material-ui/lab';

const styles = () => ({
  root: {},
});

/**
 * Displays either child content or `Skeleton`.
 * If `loading` is falsy, content will be replaced by a `Skeleton` component. Otherwise, `children` will be displayed.
 * @returns {JSX.Element}
 * @constructor
 */
const SkeletonOverlay = ({
  classes,
  className,
  children,
  loading,
  SkeletonProps,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      {loading
        ? children
        : <Skeleton {...SkeletonProps} />
      }
    </div>
  );
};

SkeletonOverlay.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * A value indicating whether or not content should be displayed. If falsy, `Skeleton` will be displayed.
   */
  loading: PropTypes.any,
  /**
   * Passthrough props for `Skeleton`
   */
  SkeletonProps: PropTypes.object,
  children: PropTypes.node.isRequired,
};

SkeletonOverlay.defaultProps = {
  className: '',
  loading: false,
  SkeletonProps: {},
};

export default withStyles(styles)(SkeletonOverlay);
